import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import React, { PropsWithChildren, ReactElement } from 'react'
import styled from 'styled-components'
import { _searchTileContainerQueryUp } from './_MetaSearchTileBase'
import SearchTileRowTitle from './shared/SearchTileRowTitle'

const Container = styled(Group)`
  grid-area: content-primary;
`

const FeaturesContainer = styled.div`
  display: none;

  ${_searchTileContainerQueryUp.desktopLarge} {
    display: block;
  }
`

interface Props extends PropsWithChildren {
  cancellationPolicyLabel?: ReactElement | false
  /**
   * Inclusions, amenities, etc.
   */
  features?: ReactElement | false
  labels?: ReactElement | false
  /**
   * Complementary content. _(Sits between header and features)_
   */
  overline?: ReactElement | false
  title: ReactElement | string
  subtitle?: string
}

function _MetaSearchTileContentPrimary({
  cancellationPolicyLabel,
  features,
  labels,
  overline,
  title,
  subtitle,
}: Props) {
  return <Container
    className={_MetaSearchTileContentPrimary.name}
    direction="vertical"
    gap={12}
  >
    <Group direction="vertical" gap={4}>
      <Group direction="horizontal" gap={8} horizontalAlign="space-between" verticalAlign="start">
        <div>
          <Group direction="vertical" gap={4}>
            {overline}
            <SearchTileRowTitle>{title}</SearchTileRowTitle>
            {subtitle && <BodyText variant="medium" colour="neutral-two">{subtitle}</BodyText>}
          </Group>
        </div>
      </Group>
      {labels}
      {cancellationPolicyLabel}
    </Group>
    {features && <FeaturesContainer>{features}</FeaturesContainer>}
  </Container>
}

export default _MetaSearchTileContentPrimary
